import { WorkCom } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { cloneDeep } from 'lodash-es';
import { WorkComVO } from '../../vo/workflow/workcom.vo';


export interface WorkComReply {
  idx?: number,
  content?: string,
  startDate?: number,
  endDate?:number,
  state?:string,
  date?: number,
  who?: string,
}

export interface WorkcomParameters {
  from?: string,
  to?: string[],
  state?: string,
  imgBlob?: string,
  media?: any, //MediaReference,
  startDate?: number,
  endDate?: number,
  replies?: WorkComReply[],
  object?: string,
  comment?: string
}

/**
 * gestion des workflows
 */
export class WorkflowEngine {

  protected _model: Model = null;
  constructor(model: Model) {
    this._model = model;
  }
 

  public reset(): void {
    this._model.workcomList = null;
    this._model.workcomMap = null;
  }

  public getWorkcomCollection(): WorkComVO[] {
      return this._model.workcomList;
  }
  public setWorkcomCollection(value: WorkComVO[]) {
      this._model.workcomList = value;
  }


  public getWorkcomMap(): Map<string, WorkComVO> {
      return this._model.workcomMap;
  }
  public setWorkcomMap(value: Map<string, WorkComVO>) {
    // TODO TODO alimenter la map par parents...  
    this._model.workcomMap = value;
  }


  /**
   * sur changement des workcom, alimentation du modèle
   * @param wcs: WorkCom[]
   */
  public buildMap(wcs: WorkCom[]): void {
    const flatList: WorkComVO[] = wcs.map((wc) => new WorkComVO(this._model, wc));
    this._model.workcomList = flatList;

    this._model.workcomMap = new Map(flatList.map(item => [item.naturalUID, item]));
  }

  /**
   * Clone d'un workcom pour édition
   * @param item le workcom à cloner
   * @return workcomVO,  Un clone
   */
  public clone(item: WorkComVO): WorkComVO {
    const clone = new WorkComVO(this._model, cloneDeep(item.source));
    return clone;
  }


  /**
   * Récupération d'un workcom par son naturalID
   * @param naturalID
   */
  public getWorkCom(naturalID: string): WorkComVO {
    let wc: WorkComVO = this._model.workcomMap?.get(naturalID);
    return wc;
  }


  /**
   * Récupération des WorkComs par le couple visionCode / parentKey
   * @param visionCode la vision de rattachement de ce WorkCom
   * @param parentKey Le code du style
   */
  public getWorkComs(visionCode: string, parentKey: string): WorkComVO[] {
    
    return this._model.workcomList;
  }

  /**
   * suppression de l'instance d'un WorkComVO
   * @param naturalID
   */
  public removeWorkCom(naturalID: string): void {
    const toDie: WorkComVO = this.getWorkCom(naturalID);
    this._model.workcomList.splice(this._model.workcomList.indexOf(toDie), 1);
    this._model.workcomMap.delete(naturalID);
    // suppression de la map par vision / parentKey
    // let byKeyArr: WorkComVO[] = this.model.workcomByParentMap.get(toDie.vision).get(toDie.parentKey);
    // byKeyArr.splice(byKeyArr.indexOf(toDie), 1);
  }

  /**
   * ajout de l'instance d'un WorkCom
   * @param vo WorkCom
   */
  public addWorkCom(wc:WorkComVO): void {
    this._model.workcomList.push(wc);
    this._model.workcomMap.set(wc.naturalUID, wc);  
  }



  private _setFields: Set<string> = null;
  /**
   * mapping des champs d'un workcom
   * @returns  le set
   */
  public setFields(): Set<string> {
    if(!this._setFields) {
      let set: Set<string> = new Set();
        set.add("object");
        set.add("comment");
        set.add("from");
        set.add("state");
        set.add("to");
        set.add("startDate");
        set.add("endDate");
        set.add("image");
        set.add("file");
      this._setFields = set;

    }
    
    return this._setFields;
   }

  /**
   * accesseur sur un champ du workcom
   * @param naturalID 
   * @param field 
   * @param who first / last
   * @returns 
   */
  public getValue(naturalID: string, field: string, who?: string): string {
    let result: string = null;
    const wc: WorkComVO = this.getWorkCom(naturalID);

    if(!wc) { 
      return null;
    }
    let targetWCR: WorkComReply;
    try {
      let firstWCR: WorkComReply = WorkflowEngine.replyFromWC(wc);
      let allWCR: WorkComReply[];
      if(wc.params?.replies) {
        allWCR = [firstWCR, ...wc.params?.replies];
      } else {
        allWCR = [firstWCR];
      }
      allWCR = allWCR.sort((a,b) => a.idx - b.idx);
      targetWCR = firstWCR;
      if(who === 'last') {
        targetWCR = allWCR.pop();
      }
    }
    catch(e: any) {
      console.log('wc bad params', wc);
    }

    switch(field) {
      case "image":
        result = wc.params?.imgBlob || null;
      break;
      case "file":
        result = wc.params?.media || null;
      break;
      case "object":
        result = wc.obj;
      break;
      case "comment":
        result = targetWCR?.content;
      break;
      case "state":
        result = targetWCR?.state;
      break;
      case "to":
        result = wc.params?.to?.join(";");
      break;
      case "from":
        result = targetWCR?.who;
      break;
      case "startDate":
        if(targetWCR?.startDate) {
          result = targetWCR.startDate?.toString() || null;
        }
      break;
      case "endDate":
        if(targetWCR?.endDate) {
            result = targetWCR.endDate?.toString() || null;
        }
      break;
    }

    return result;
  }



  /**
   * conversion du workflow en message
   * @param wc 
   * @returns 
   */
  public static replyFromWC(wc: WorkComVO): WorkComReply {
    let firstMess: WorkComReply =  {
        idx: -1, 
        content: wc.comment, 
        date: wc.createTime, 
        who: wc.createBy,
      };

      if(wc.params?.startDate) {
        firstMess.startDate = wc.params.startDate;
      }
      if(wc.params?.endDate) {
        firstMess.endDate = wc.params.endDate;
      }

      if(wc.params?.state) {
        firstMess.state = wc.params.state;
      }
    return firstMess;
  }


}


